import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnTime = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M12 8.914v4.548m-6-8.49L9 3m9 1.971L15 3M4 11.303v3.106c0 1.78.974 3.422 2.549 4.295l3 1.663a5.06 5.06 0 0 0 4.902 0l3-1.663A4.92 4.92 0 0 0 20 14.409v-3.106c0-1.78-.974-3.422-2.549-4.295l-3-1.663a5.06 5.06 0 0 0-4.902 0l-3 1.663A4.92 4.92 0 0 0 4 11.303Z"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M12 14h0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnTime;
